import { useEffect, useState } from 'react'
import { Button, FormInput } from 'components'
import { ScheduleEditor } from './schedule-editor'

export const DungeonAdminForm = ({ initial = {}, onSubmit, submitLabel = 'Save' }) => {
  const [state, setState] = useState({
    name: '',
    slug: '',
    lat: '',
    lng: '',
    radius: 200,
    is_global: false,
    is_popup: false,
    schedule: null,
    ...initial,
    lat: initial.lat ?? '',
    lng: initial.lng ?? '',
  })

  const handler = ({ target: { name, value } }) => {
    setState((prev) => ({ ...prev, [name]: value }))
  }

  // Auto-generate slug from name only when creating (no initial slug)
  useEffect(() => {
    if (initial.slug) return
    const slug = state.name.replace(/'/g, '').replace(/[^a-z0-9]+/gi, '-').toLowerCase()
    setState((prev) => ({ ...prev, slug }))
  }, [state.name])

  const handleSubmit = () => {
    onSubmit({
      name:      state.name,
      slug:      state.slug,
      lat:       state.lat !== '' ? parseFloat(state.lat) : null,
      lng:       state.lng !== '' ? parseFloat(state.lng) : null,
      radius:    state.radius !== '' ? parseInt(state.radius) : null,
      is_global: !!state.is_global,
      is_popup:  !!state.is_popup,
      schedule:  state.schedule || null,
    })
  }

  return (
    <>
      <FormInput label="Name"            name="name"   onChange={handler} value={state.name} />
      <FormInput label="Slug"            name="slug"   onChange={handler} value={state.slug} />
      <FormInput label="Latitude"        name="lat"    onChange={handler} value={state.lat ?? ''}    type="number" step="any" />
      <FormInput label="Longitude"       name="lng"    onChange={handler} value={state.lng ?? ''}    type="number" step="any" />
      <FormInput label="Radius (metres)" name="radius" onChange={handler} value={state.radius ?? ''} type="number" />
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Silkscreen', monospace", fontSize: '0.9rem' }}>
        <input
          type="checkbox"
          checked={!!state.is_global}
          onChange={(e) => setState((prev) => ({ ...prev, is_global: e.target.checked }))}
        />
        Global dungeon (spawns anywhere)
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontFamily: "'Silkscreen', monospace", fontSize: '0.9rem', marginTop: '0.5rem' }}>
        <input
          type="checkbox"
          checked={!!state.is_popup}
          onChange={(e) => setState((prev) => ({ ...prev, is_popup: e.target.checked }))}
        />
        Pop-up dungeon (hidden from map when closed; only visible during schedule)
      </label>
      <ScheduleEditor
        value={state.schedule}
        onChange={(schedule) => setState((prev) => ({ ...prev, schedule }))}
      />
      <div style={{ marginTop: '1rem' }}>
        <Button className="large" onPress={handleSubmit}>{submitLabel}</Button>
      </div>
    </>
  )
}
